import config from "config";
import { request } from "Resources/AxiosUtils";
import { IRequestAssetUploadResponse } from "./types";

const LIVEPEER_AUTHENTICATION_HEADERS = {
    headers: {
        Authorization: `Bearer ${config.get('LIVEPEER_API_KEY')}`,
        'Content-Type': 'application/json',
    }
};

export async function requestAssetUpload(fileName: string) {
    const response = await request<IRequestAssetUploadResponse>({
        url: "https://livepeer.studio/api/asset/request-upload",
        method: "POST",
        data: { name: fileName },
        ...LIVEPEER_AUTHENTICATION_HEADERS,
    });
    return response;
}
